// Blog post types - separated to avoid importing fs in client components

export type BlogPostSummary = {
  title: string
  publishedAt: string
  /** Last day the body changed. Falls back to `publishedAt` in JSON-LD. */
  updatedAt?: string
  summary: string
  /** Meta description. Mirrors `summary` when omitted. */
  description?: string
  image: string
  author: string
  slug: string
  category?: string
  readingTime?: number
}
// Backwards-compatible alias for list consumers that previously imported Post.
export type Post = BlogPostSummary

export type Category = {
  label: string
  color: string
}

export const categories: Record<string, Category> = {
  comparison: {
    label: 'Comparison',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
  guide: {
    label: 'Guide',
    color:
      'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  strategy: {
    label: 'Strategy',
    color:
      'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  },
  tips: {
    label: 'Tips',
    color:
      'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  },
  data: {
    label: 'Data & Insights',
    color: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-300',
  },
  news: {
    label: 'News',
    color: 'bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300',
  },
}
